import { render, staticRenderFns } from "./InsertAfterSlideCopy.vue?vue&type=template&id=49f30e54&"
import script from "./InsertAfterSlideCopy.vue?vue&type=script&lang=js&"
export * from "./InsertAfterSlideCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports